import { jwtDecode } from "jwt-decode";
import { getUserInfoFromToken as decodeUserInfoFromToken } from "./util";

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded?.exp > currentTime;
    // return 1780417800 > currentTime;
  } catch {
    return false;
  }
};

export const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token && isTokenValid(token) ? token : null;
};

export const requireAuthToken = () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Authentication required. Please log in.");
  }
  return token;
};

export const getAuthBearerHeaders = (extraHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };

  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const formatRoleLabel = (role) =>
  String(role || "user")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getUserInfoFromToken = (token) => {
  const user = decodeUserInfoFromToken(token);
  if (!user) return null;

  const normalizedRoles = Array.isArray(user.roles)
    ? user.roles.map((role) => String(role).toLowerCase()).filter(Boolean)
    : [];

  const primaryRole = normalizedRoles.includes("admin")
    ? "admin"
    : normalizedRoles.includes("super admin")
      ? "super admin"
      : normalizedRoles[0] || "user";

  return {
    ...user,
    roles: normalizedRoles,
    role: primaryRole,
    roleLabel: formatRoleLabel(primaryRole),
  };
};
